export default "__VITE_ASSET__DGfJi3QN__"